import { TypeAnimation } from "react-type-animation";

// model_card HERO + performance-metrics table.
// Replaces the old image-bg hero. No router needed — buttons scroll.

const skills = ["Python", "SQL", "pandas", "scikit-learn", "Power BI", "Streamlit", "Git", "dbt", "BigQuery"];
const learning = ["TensorFlow", "PyTorch", "Hugging Face", "RAG / LLMs"];
const tools = ["Looker Studio", "Jupyter", "Google Colab", "Excel", "Google Sheets", "VS Code"];

const metrics = [
  ["tenure", "BrightChamps (EdTech)", "5+ yrs"],
  ["promotions", "analyst → eval lead", "4×"],
  ["manual_effort", "reporting automation", "−50–70%"],
  ["workflow_coverage", "cross-functional analytics", "30%"],
  ["tutors_trained", "concurrent instructor role", "500+"],
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const Home = () => {
  return (
    <section id="home">
      {/* ── hero band ── */}
      <div className="band">
        <div className="wrap">
          <div className="kicker" data-aos="fade-up">MODEL CARD — ANALYST → ML → AI</div>
          <h1 className="mc-h1" data-aos="fade-up" data-aos-delay="80">
            Mohamed&nbsp;Ansaar <span className="v">v3.0</span>
          </h1>
          <p className="lede" data-aos="fade-up" data-aos-delay="160">
            An analytics engineer being fine-tuned toward ML &amp; AI engineering.{" "}
            <TypeAnimation
              sequence={[
                "Five years of shipped data systems.", 2200,
                "Dashboards, pipelines, predictive models.", 2200,
                "And the loss is still going down.", 2600,
              ]}
              speed={45}
              repeat={Infinity}
              className="lede-type"
            />
          </p>

          <div className="badges" data-aos="fade-up" data-aos-delay="240">
            {skills.map((s) => (
              <span className="badge" key={s}><b>{s}</b></span>
            ))}
            {learning.map((s) => (
              <span className="badge" key={s}>{s} <span className="lr">·learning</span></span>
            ))}
            <span className="divider">{"// tooling"}</span>
            {tools.map((s) => (
              <span className="badge tool" key={s}>{s}</span>
            ))}
          </div>

          <div className="hero-cta" data-aos="fade-up" data-aos-delay="320">
            <button className="mc-btn" onClick={() => scrollTo("projects")}>▸ view projects</button>
            <button className="mc-btn ghost" onClick={() => scrollTo("contact")}>▷ get in touch</button>
          </div>
        </div>
      </div>

      {/* ── performance metrics ── */}
      <div className="sec" id="metrics">
        <div className="wrap">
          <div className="sec-h"><span className="hash">##</span> performance metrics</div>
          <table className="mc-table">
            <thead>
              <tr><th>metric</th><th>source</th><th className="ra">value</th></tr>
            </thead>
            <tbody>
              {metrics.map(([m, src, v]) => (
                <tr key={m}>
                  <td className="metric">{m}</td>
                  <td className="src">{src}</td>
                  <td className="val"><span className="up">{v}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default Home;